import './email-body-display.scss';

import EmailBodyDisplay from './EmailBodyDisplay';

export default EmailBodyDisplay;
